<head-meta title="Verify"></head-meta>
<div class="flex min-h-full flex-col justify-center py-12 sm:px-6 lg:px-8">
  <div class="sm:mx-auto sm:w-full sm:max-w-md">
    <img class="mx-auto h-20 w-auto" src="/assets/arborsense.png"
      alt="Arborsense">
  </div>
  <div class="mt-10 sm:mx-auto sm:w-full sm:max-w-[480px]">
    <div class="card w-full bg-base-100 shadow-xl">
      <div class="card-body">
        <div class="space-y-6">
          <ng-container *ngrxLet="tokenValid$ as tokenValid; error as e; complete as c">
            @if(tokenValid) {
              <ng-container *ngrxLet="tokenNotExpired$ as tokenNotExpired; error as e; complete as c">
                @if(tokenNotExpired) {
                  <small>Clicking this button will verify your identity and log you into the application.</small>
                  <button type="submit" (click)="this.navToVerify()" class="flex w-full justify-center btn btn-primary">Continue Login</button>
                } @else {
                  <small>This link is expired, please request another.</small>
                }
              </ng-container>
            } @else {
              <small>This link has already been used (or something went wrong). Please try again.</small>
            }
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</div>
<app-toast #messageToast type="success" />